// removed by extract-text-webpack-plugin
module.exports = {"theme":"#e26831","themeBg":"#f3f7f8","textColor":"#e26831","subTextColor":"#999","activeColor":"#fff"};


//////////////////
// WEBPACK FOOTER
// ./src/style/index.scss
// module id = +qiL
// module chunks = 26